document.addEventListener("DOMContentLoaded", () => {
  class PcSelectorPopup extends HTMLElement {
    constructor() {
      super();

      this.data = [];
      this.selectedValue = null;
      this.anchorEl = null;

      this.style.display = "none";

      // portal
      this.portal = document.createElement("div");
      this.portal.className = this.getAttribute("portal-class");
      this.portal.style.position = "absolute";
      this.portal.style.zIndex = "24";
      this.portal.style.display = "none";

      document.body.appendChild(this.portal);

      this.onDocClick = this.onDocClick.bind(this);

      this.trackedProducts = new Set();
    }

    open({ data, selectedValue, anchorEl }) {
      this.data = data;
      this.selectedValue = selectedValue;
      this.anchorEl = anchorEl;

      $("body").css("overflow-x", "hidden");

      this.render();
      this.position();
      this.portal.style.display = "block";

      document.addEventListener("click", this.onDocClick);
      this.isShow = true
    }

    close() {
      this.portal.style.display = "none";
      $("body").css("overflow-x", "");
      document.removeEventListener("click", this.onDocClick);
      this.isShow = false
    }

    render() {
      this.portal.innerHTML = "";

      this.data.forEach((product) => {
        const isSelected = product.handle === this.selectedValue;
        const item = document.createElement("div");

        item.className = `xmas-swiper-card-selector-option${
          isSelected ? " selected" : ""
        }`;
        item.dataset.value = product.handle;
        item.textContent = product.title;

        item.addEventListener("click", (e) => {
          e.stopPropagation();
          this.confirm(product.handle);

          // === 埋点逻辑 ===
          if (this.trackedProducts.has(product.handle)) return; // 已埋点就跳过

          let scrollTop = window.scrollY || document.documentElement.scrollTop;
          let windowHeight =
            window.innerHeight || document.documentElement.clientHeight;
          let docHeight = document.documentElement.scrollHeight;

          let item_list_name =
            scrollTop + windowHeight / 2 < docHeight / 2
              ? "Christmas Gift Sets for Every Corner of Home"
              : "Get 1 Year of Accessories with Your Device";

          window.dataLayer.push({ ecommerce: null });

          window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
              item_list_id: `${data_event_id}`,
              item_list_name: item_list_name,
              items: [
                {
                  item_id: product.id,
                  item_name: product.fullTitle||product.title,
                  item_category: product.type,
                  item_brand: "dreame",
                  price: product.price ? product.price / 100 : 0,
                  index: 0,
                  quantity: 1,
                },
              ],
            },
          });

          this.trackedProducts.add(product.handle); // 标记已埋点
        });

        this.portal.appendChild(item);
      });

      // 阻止点 options 自身冒泡
      this.portal.addEventListener("click", (e) => e.stopPropagation());
    }

    position() {
      if (!this.anchorEl) return;

      const rect = this.anchorEl.getBoundingClientRect();

      this.portal.style.top = rect.bottom + window.scrollY + "px";
      this.portal.style.left = rect.left + window.scrollX + "px";
      this.portal.style.width = rect.width + "px";
    }

    confirm(value) {
      this.dispatchEvent(
        new CustomEvent("confirm", {
          detail: { value },
          bubbles: true,
          composed: true,
        })
      );
      this.close();
    }

    onDocClick() {
      this.close();
    }

    disconnectedCallback() {
      this.close();
      if (this.portal.parentNode) {
        this.portal.parentNode.removeChild(this.portal);
      }
    }
  }

  customElements.define("pc-selector-popup", PcSelectorPopup);
});
